/**
 * Base del API Django bajo /tienda/ (misma convención que operaciones y reservas).
 * Usa VUE_APP_API_URL_TIENDA o, si falta, VUE_APP_API_URL (terminando en …/tienda/).
 */
export function tiendaApiBase() {
  const primary = (process.env.VUE_APP_API_URL_TIENDA || '').trim();
  const fallback = (process.env.VUE_APP_API_URL || '').trim();
  return (primary || fallback).replace(/\/?$/, '/');
}
